import { useQueries, UseQueryResult } from '@tanstack/react-query';
import { getBrand } from '../../api/brand.ts';
import { Brand } from '../../models/Brand.ts';
import { PlaceService } from '../../models/PlaceService.ts';

const getBrandId = (service: PlaceService): string | undefined => {
  return service.brandId ?? undefined;
};

export function useBrands(
  services: PlaceService[] | undefined,
  selectedLocationId: string | undefined,
): UseQueryResult<Brand, Error>[] {
  const queries =
    services && selectedLocationId
      ? services.map((service) => {
          const brandId = getBrandId(service);
          return {
            queryKey: [
              'selectedLocation',
              selectedLocationId,
              'brands',
              service.id,
              brandId,
            ] as const,
            queryFn: () => getBrand(brandId!),
            enabled: !!brandId,
          };
        })
      : [];

  return useQueries({ queries }) as UseQueryResult<Brand, Error>[];
}
